import { AutogenModelEdistatus, AutogenRowEdistatus } from "./autogen/AutogenModelEdistatus";

export class ModelEdistatus extends AutogenModelEdistatus<RowEdistatus> {
    constructor() {
        super(RowEdistatus);
    }
}

export class RowEdistatus extends AutogenRowEdistatus {
}